import { FolderOpenOutlined, PhoneOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { MEETING_TYPES, MeetingType } from 'commons/types/meetingsTypes';
import { Link } from 'react-router-dom';

const CONTENT: Record<MeetingType, string> = {
  RDV_1: 'Le conseiller médical vous appelera directement',
  RDV_2: "Pensez à votre carte vitale et carte d'identité",
  RDV_3: 'Pensez à votre justificatif (ordonnance, CMU/ALD si necessaire)',
  RDV_PPC: 'Votre RDV est confirmé.',
  RDV_SWITCH: 'Votre RDV est confirmé.',
  None: 'Votre RDV est confirmé.',
};
export default function VerifyMeeting({ type }: { type: MeetingType }) {
  return (
    <div className='text-center'>
      <h2 className='text-lg font-semibold mb-0'>Rendez-vous confirmé</h2>
      {type === MEETING_TYPES.RDV_1 ? (
        <PhoneOutlined className='text-[56px] my-8' />
      ) : (
        <FolderOpenOutlined className='text-[56px] my-8' />
      )}

      <p className='font-semibold'>{CONTENT[type]}</p>
      <p className='text-xs mb-8' />
      <Link to='/'>
        <Button
          type='primary'
          className='mt-4 !rounded-[32px] !h-10 !font-semibold'
        >
          Accéder à mon espace patient
        </Button>
      </Link>
    </div>
  );
}
